import {DescriptionText} from "../../../../../design";
import React from "react";

type Props = {
  header: string,
  body: string,
}

const InvoiceDetailsItem = (props:Props) => {
  const { header, body } = props;
  return (
    <div className="col-12 col-md-5">
      <DescriptionText>{header}</DescriptionText>
      <DescriptionText color="#000000" fontWeight="400">
        {body || "N.A."}
      </DescriptionText>
    </div>
  )
};

export default InvoiceDetailsItem
